import React, { useContext, useEffect, useState, useRef } from "react";
import "../../../../CapsitechAccountsComponents/Pages/Assets/Css/Assets.css";
import {
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
  FilterOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import {
  Row,
  Button,
  Input,
  Table,
  Tooltip,
  Col,
  Card,
  Select,
  InputRef,
  Skeleton,
  Space,
  Checkbox,
  TableColumnType,
  Popover,
} from "antd";
import { FilterDropdownProps } from "antd/es/table/interface";
import { ColumnsType } from "antd/es/table";
import FixedAssetsService, {
  AssetStatus_New,
  IFAListResponse,
} from "../../../Services/FixedAssetsServiceNew";
import { useClient } from "../../../Context/ClientContext";
import { useTheme } from "../../../Context/ThemeContext";
import search from "../../../Images/search.svg";
import { Utils } from "../../../../Utilities/Utils";
import ViewAssetModel from "../ViewAssetModel";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { findUserPremission } from "../../Users/Roles/UserSecurityFind";
import { useUser } from "../../../../Context/UserContext";
import { SettingsSections } from "../../../Services/SettingService";
import { IPermissionActionType } from "../../Users/Roles/UserPermissionCommonData";
import { ITypeIIsClientSpecificRoleDataType } from "../../../../Context/RoleContext";
import AddAssetItems from "./AddAssetItems";
import { ItemAdd_Type } from "../../../Services/ItemsService";
import AssetJournalModal from "../AssetJournalModal";
import {
  NumberSearchTableEnum,
  NumberSearchTableOption,
  TextSearchTableEnum,
  TextSearchTableOption,
} from "../../../Common/SearchTableOptions";
import { tablePageSizeOptions } from "../../../Common/ThemeSetting";

const IsDepreciableOption = [
  {
    label: "No",
    value: false,
  },
  {
    label: "Yes",
    value: true,
  },
];

interface IDataType {
  key: string;
  id: string;
  sno: number;
  number: string;
  name: string;
  purPrice: number;
  taxRate: number;
  date: string;
  price: string;
  isDepreciable: string;
  status: AssetStatus_New;
  invoiceDetail: any;
  groupName: string;
  groupId: string;
  // journals: any[];
  // jrNumber: any[];
}
// interface ExpandedDataType {
//   key: React.Key;
//   date: string;
//   gst: any;
//   invNumber: string;
//   partiallyPaidAmount: number;
//   price: number;
//   purPartyLedger: string;
//   purPayDate: string;
//   purPayMethod: PmtMethod;
//   purPayRef: string;
//   purPaymentLedger: string;
//   qty: number;
//   taxCredit: boolean;
//   voucherDate: string;
//   childAssetDetail: ChildAssetDetail[];
// }

// interface ChildAssetDetail {
//   accumulatedDepreciation: number;
//   childAssetName: string;
//   childAassetNumber: string;
//   depAmount: number;
//   depreciationLastDate: string;
//   depreciationStartDate: string;
//   description: string;
//   disposalDate: string;
//   disposalPartyLedger: string;
//   disposalPaymentLedger: string;
//   disposalPaymentRef: string;
//   disposalValue: number;
//   identityCode: string;
//   isDisposed: boolean;
//   lifeCycleDuration: number;
//   location: string;
//   model: string;
//   residualValue: number;
//   warrantyExpDate: string;
//   wdValue: number;
//   wdvDate: string;
//   writeOffValue: number;
// }

const AssteItemsTable = ({
  setFixedAssetListPassToOpeningBalance,
  // setOpenAssetModal,
  assetPurchaseType,
}: {
  setFixedAssetListPassToOpeningBalance?: React.Dispatch<
    React.SetStateAction<any[]>
  >;
  assetPurchaseType?: boolean;
}) => {
  type DataIndex = keyof IFAListResponse;
  const { currentClient, companySettings } = useClient();
  const { clientSpecificRole } = useUser();
  const { openNotification } = useContext(notificationContext);
  const { themeData } = useTheme();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isConfirmation, setIsConfirmation] = useState<boolean>(false);
  const [successRollBack, setSeccesRollBack] = React.useState<boolean>(false);
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [fixedAssetList, setFixedAssetList] = React.useState<IFAListResponse[]>(
    []
  );
  const [loading, setLoading] = React.useState<boolean>(false);
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const [searchAsset, setSearchAsset] = React.useState("");
  const [isViewModelOpen, setIsViewModelOpen] = useState<boolean>(false);
  const [assetId, setAssetId] = React.useState<{
    assetId: string;
    childAssetName: string;
  }>({
    assetId: "",
    childAssetName: "",
  });
  const [confirmation, setConfirmation] = React.useState<boolean>(false);
  const [type, setType] = React?.useState<boolean>(Boolean);

  const [changeStatus, setChangeStatus] = React.useState<number>(
    AssetStatus_New.Active
  );

  const [deleteOrRevive, setDeleteOrRevive] = React.useState<any>({
    id: "",
    isRev: null,
  });

  const [assetModelOpen, setAssetModelOpen] = React.useState<{
    open: boolean;
    param: string;
    openingAsset: boolean;
  }>({ open: false, param: "", openingAsset: false });

  const [journalModel, setJournalModel] = React.useState<{
    open: boolean;
    data: any;
  }>({ open: false, data: {} });
  const [refreshAtDelete, setRefreshAtDelete] = React.useState<boolean>(false);
  const [width, setWidth] = useState<any>(window.innerWidth);
  const [openDropdown, setOpenDropdown] = useState<DataIndex | null>(null);
  const [exportItemsData, setExportItemsData] = useState<any>([]);
  const [searchColumns, setSearchColumns] = useState<any>({
    name: "",
    number: "",
    groupName: "",
    purPrice: "",
    taxRate: [],
    isDepreciable: null,
  });
  const [searchColumnCount, setSearchColumnCount] = useState<number>(0);
  const [searchColumnsDropDown, setSearchColumnsDropDown] = useState<{
    nameDropEnum: TextSearchTableEnum;
    nameDropPre: TextSearchTableEnum;
    numberDropEnum: TextSearchTableEnum;
    numberDropPre: TextSearchTableEnum;
    groupNameEnum: TextSearchTableEnum;
    groupNamePre: TextSearchTableEnum;
    purchasePriceDropEnum: NumberSearchTableEnum;
    purchasePriceDropPre: NumberSearchTableEnum;
  }>({
    nameDropEnum: TextSearchTableEnum.contains,
    nameDropPre: TextSearchTableEnum.contains,
    numberDropEnum: TextSearchTableEnum.contains,
    numberDropPre: TextSearchTableEnum.contains,
    groupNameEnum: TextSearchTableEnum.contains,
    groupNamePre: TextSearchTableEnum.contains,
    purchasePriceDropEnum: NumberSearchTableEnum.equalTo,
    purchasePriceDropPre: NumberSearchTableEnum.equalTo,
  });

  const [filter, setfilter] = useState<{ sortCol: string; sortDir: string }>({
    sortCol: "",
    sortDir: "",
  });

  const searchInput = useRef<InputRef>(null);
  const searchSelect = useRef<any>(null);
  const companyGstAndNotGst = [
    ...companySettings?.gsts!,
    {
      name: "Not GST Item",
      id: -1,
      rate: null,
    },
  ];
  console.log("data", companyGstAndNotGst);

  // const showModal = () => {
  //   setEditAsset({ id: null });
  //   setIsModalOpen(true);
  // };

  // const modelCancel = () => {
  //   setIsModalOpen(false);
  //   setIsConfirmation(false);
  //   // form.resetFields();
  // };

  // for getlist
  useEffect(() => {
    setLoading(true);
    const requestModel = {
      name: searchColumns.name?.trim(),
      nameDropEnum: searchColumnsDropDown.nameDropEnum,

      number: searchColumns.number?.trim(),
      numberDropEnum: searchColumnsDropDown.numberDropEnum,

      groupName: searchColumns.groupName?.trim(),
      groupNameDropEnum: searchColumnsDropDown.groupNameEnum,

      purchasePrice:
        searchColumnsDropDown.purchasePriceDropEnum ===
        NumberSearchTableEnum.contains
          ? String(searchColumns.purPrice ?? "")
          : Utils.getIsNaNReturnNull(
              String(searchColumns.purPrice ?? "").replace(/,/g, "")
            ),
      purchasePriceDropEnum: searchColumnsDropDown.purchasePriceDropEnum,
      gstRate: searchColumns.taxRate,
      isDepreciable: searchColumns.isDepreciable,
    };

    getList(
      currentClient?.id!,
      (page - 1) * pageSize,
      pageSize,
      filter.sortCol,
      filter.sortDir,
      searchAsset,
      changeStatus,
      assetPurchaseType ? ItemAdd_Type.Opening : ItemAdd_Type.New,
      requestModel
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentClient?.id,
    trigger,
    page,
    pageSize,
    searchAsset,
    changeStatus,
    refreshAtDelete,
    successRollBack,
    searchColumns,
    filter.sortCol,
    filter.sortDir,
  ]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);
  // Api Asset Items Get List
  const getList = async (
    clientId: string,
    start: number,
    length: number,
    sortCol: any,
    sortDir: any,
    search: string,
    status: AssetStatus_New,
    type: ItemAdd_Type,
    requestModel?: {
      gstRate?: number[];
      name?: string | null;
      nameDropEnum?: TextSearchTableEnum;
      number?: string | null;
      numberDropEnum?: TextSearchTableEnum;
      groupName?: string | null;
      groupNameDropEnum?: TextSearchTableEnum;
      purchasePrice?: string | number;
      purchasePriceDropEnum?: NumberSearchTableEnum;
    }
  ) => {
    await FixedAssetsService.getFixedAssetsList(
      clientId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      status,
      type,
      requestModel
    )
      .then(({ result }) => {
        if (result?.items?.length > 0) {
          setFixedAssetList(
            result?.items?.map((e, index: number) => {
              return {
                sno: index + 1,
                id: e?.id,
                name: e?.name,
                number: e?.number,
                isDepreciable: e?.isDepreciable,
                purPrice: e?.purPrice,
                taxRate: e?.taxRate,
                assetLocation: e?.assetLocation,
                depMethod: e?.depMethod,
                depRate: e?.depRate,
                lifeCycleDuration: e?.lifeCycleDuration,
                isAssetDisposed: e?.isAssetDisposed,
                status: e?.status,
                groupName: e?.groupName,
                groupId: e?.groupId,
                categoryName: e?.categoryName,
                categoryId: e?.categoryId,
                itemAddType: e?.itemAddType,
              };
            }) || []
          );
          setTotalRecords(result?.totalRecords);
          setFixedAssetListPassToOpeningBalance &&
            setFixedAssetListPassToOpeningBalance(result?.items);
        } else if (result.items.length === 0) {
          setFixedAssetList([]);
          setTotalRecords(result?.totalRecords);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
    setLoading(false);
  };

  // console.log("fixedAssetList: ", fixedAssetList);

  // // ----- Short-Cut for Open Model -----F
  // useKeyboardShortcuts("N", ["shiftKey"], () => {
  //   setIsModalOpen(true);
  // });

  const checkFilterType = (dataIndex: DataIndex) => {
    let isFilterTypeUnchanged = false;
    switch (dataIndex) {
      case "name":
        isFilterTypeUnchanged =
          searchColumnsDropDown.nameDropEnum ===
          searchColumnsDropDown.nameDropPre;
        break;
      case "number":
        isFilterTypeUnchanged =
          searchColumnsDropDown.numberDropEnum ===
          searchColumnsDropDown.numberDropPre;
        break;
      case "groupName":
        isFilterTypeUnchanged =
          searchColumnsDropDown.groupNameEnum ===
          searchColumnsDropDown.groupNamePre;
        break;
      case "purPrice":
        isFilterTypeUnchanged =
          searchColumnsDropDown.purchasePriceDropEnum ===
          searchColumnsDropDown.purchasePriceDropPre;
        break;
    }

    return isFilterTypeUnchanged;
  };

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    const prevValue = searchColumns[dataIndex];

    const isMulti = dataIndex === "isDepreciable" || dataIndex === "taxRate";
    let newValue: any;

    if (isMulti) {
      newValue = Array.isArray(selectedKeys) ? selectedKeys : [];
    } else {
      newValue =
        selectedKeys && selectedKeys[0] ? String(selectedKeys[0]).trim() : "";
    }

    if (isMulti) {
      const prevArr = Array.isArray(prevValue) ? prevValue : [];
      const sameLength = prevArr.length === newValue.length;
      const sameItems =
        sameLength && prevArr.every((v: any, i: number) => v === newValue[i]);

      // empty selection + no previous -> do nothing
      if (!newValue.length && !prevArr.length) {
        confirm();
        setOpenDropdown(null);
        return;
      }

      if (sameItems) {
        confirm();
        setOpenDropdown(null);
        return;
      }
    } else {
      if (
        newValue === String(prevValue || "").trim() &&
        checkFilterType(dataIndex)
      ) {
        confirm();
        setOpenDropdown(null);
        return;
      }
    }

    if (!isMulti) {
      setSearchColumnsDropDown((prevState) => {
        const newState = { ...prevState };
        switch (dataIndex) {
          case "name":
            newState.nameDropPre = prevState.nameDropEnum;
            break;
          case "number":
            newState.numberDropPre = prevState.numberDropEnum;
            break;
          case "groupName":
            newState.groupNamePre = prevState.groupNameEnum;
            break;
          case "purPrice":
            newState.purchasePriceDropPre = prevState.purchasePriceDropEnum;
            break;
        }
        return newState;
      });
    }

    const wasEmpty =
      !prevValue ||
      (Array.isArray(prevValue)
        ? prevValue.length === 0
        : String(prevValue).trim() === "");
    const isNowPopulated =
      (Array.isArray(newValue) && newValue.length > 0) ||
      (!Array.isArray(newValue) && newValue !== "");

    if (wasEmpty && isNowPopulated) {
      setSearchColumnCount((prev) => prev + 1);
    } else if (!wasEmpty && !isNowPopulated) {
      setSearchColumnCount((prev) => prev - 1);
    }

    const newSearchColumns = { ...searchColumns };
    if (isMulti) {
      // const key = dataIndex === "taxRate" ? "taxRate" : dataIndex;
      newSearchColumns[dataIndex] = newValue.length ? newValue : null;
    } else {
      newSearchColumns[dataIndex] = newValue;
    }
    setSearchColumns(newSearchColumns);
    confirm();
    setOpenDropdown(null);
  };

  const handleDropdownText = (
    dataIndex: DataIndex,
    valDropDown: TextSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "name":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          nameDropEnum: valDropDown,
          nameDropPre: searchColumnsDropDown.nameDropEnum,
        });
        break;
      case "number":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          numberDropEnum: valDropDown,
          numberDropPre: searchColumnsDropDown.numberDropEnum,
        });
        break;
      case "groupName":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          groupNameEnum: valDropDown,
          groupNamePre: searchColumnsDropDown.groupNameEnum,
        });
        break;
    }
  };

  const handleDropdownNumber = (
    dataIndex: DataIndex,
    valDropDown: NumberSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "purPrice":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          purchasePriceDropEnum: valDropDown,
          purchasePriceDropPre: searchColumnsDropDown.purchasePriceDropEnum,
        });
        break;
    }
  };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();

    const key = dataIndex;
    const prevValue = searchColumns[key];
    const hadValue = Array.isArray(prevValue)
      ? prevValue.length > 0
      : !!(prevValue && String(prevValue).trim().length);

    if (!hadValue) {
      setOpenDropdown(null);
      return;
    }
    setSearchColumnCount((prev) => prev - 1);
    setSearchColumns((prev: any) => {
      const copy = { ...prev };
      if (key === "taxRate" || key === "isDepreciable") {
        copy[key] = null;
      } else {
        copy[key] = "";
      }
      return copy;
    });
    setOpenDropdown(null);
    setTrigger((t) => !t);
  };

  const tableSort = (sorter: any) => {
    const s = Array.isArray(sorter) ? sorter[0] : sorter;
    const order =
      s?.order === "ascend" ? "asc" : s?.order === "descend" ? "desc" : "";
    const col = (s?.columnKey ?? s?.field) || "";

    setfilter((prev) => ({ ...prev, sortCol: col, sortDir: order }));
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    isNumber: boolean,
    searchPlaceHolder?: string
  ): TableColumnType<IFAListResponse> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyPress={(e) => e.stopPropagation()}
      >
        {dataIndex === "taxRate" ? (
          <Checkbox.Group
            options={companyGstAndNotGst?.map((gst: any) => ({
              key: gst.name,
              value: gst.id,
              title: gst.rate,
              label: gst.name,
            }))}
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
            value={selectedKeys}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
          />
        ) : dataIndex === "isDepreciable" ? (
          <Checkbox.Group
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
              width: "200px",
            }}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
            value={selectedKeys}
            options={IsDepreciableOption?.map((x: any) => ({
              value: x.value,
              label: x.label,
            }))}
          />
        ) : (
          <>
            {isNumber ? (
              <Select
                defaultValue={NumberSearchTableEnum.equalTo}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                }}
                onChange={(val: NumberSearchTableEnum) => {
                  setExportItemsData([]);
                  handleDropdownNumber(dataIndex, val);
                }}
                options={NumberSearchTableOption?.map((x: any) => ({
                  value: x.value,
                  label: x.label,
                }))}
              />
            ) : (
              <Select
                defaultValue={TextSearchTableEnum.contains}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                }}
                onChange={(val: TextSearchTableEnum) => {
                  setExportItemsData([]);
                  handleDropdownText(dataIndex, val);
                }}
                options={TextSearchTableOption?.map((x: any) => ({
                  value: x.value,
                  label: x.label,
                }))}
              />
            )}
            <Input
              ref={searchInput}
              placeholder={`Search ${searchPlaceHolder}`}
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() =>
                handleSearch(selectedKeys as string[], confirm, dataIndex)
              }
              onKeyPress={(e: any) => {
                if (dataIndex === "purPrice") {
                  if (!/\d|[.,]/.test(e.key)) e.preventDefault();
                  const curr =
                    (e.currentTarget as HTMLInputElement).value || "";
                  if (e.key === "." && curr.includes(".")) e.preventDefault();
                }
              }}
              style={{ marginBottom: 8, display: "block", width: "200px" }}
            />
          </>
        )}
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}

            size="small"
            style={{ width: 95 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 95 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) =>
      dataIndex === "taxRate" || dataIndex === "isDepreciable" ? (
        <FilterOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ) : (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    filterDropdownOpen: openDropdown === dataIndex,
    filterDropdownProps: {
      placement: "bottomLeft",
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          if (dataIndex === "taxRate") {
            searchSelect.current?.focus();
          } else {
            searchInput.current?.select();
          }
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  const permissionEdit = findUserPremission(
    ["Voucher.Asset.11.Edit"],
    clientSpecificRole(),
    currentClient?.id!,
    [SettingsSections.Asset],
    {
      actionType: IPermissionActionType.Edit,
      dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
    }
  );

  const permissionDelete = findUserPremission(
    ["Voucher.Asset.11.Delete"],
    clientSpecificRole(),
    currentClient?.id!,
    [SettingsSections.Asset],
    {
      actionType: IPermissionActionType.Delete,
      dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
    }
  );

  // Table columns
  const columns: ColumnsType<IFAListResponse> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    // {
    //   title: "Asset Reference",
    //   dataIndex: "number",
    //   key: "number",
    //   render: (_, record: any) => (
    //     <Skeleton
    //       active
    //       loading={loading}
    //       paragraph={{ rows: 1 }}
    //       title={false}
    //     >
    //       <span
    //         style={{ cursor: "pointer", color: "#1677FF" }}
    //         onClick={() => {
    //           setIsViewModelOpen(true);
    //           setAssetId({
    //             assetId: record?.id,
    //             childAssetName: record?.name,
    //           });
    //           setType(false);
    //         }}
    //       >
    //         {record?.number}
    //       </span>
    //     </Skeleton>
    //   ),
    // },
    {
      title: "Asset Name",
      dataIndex: "name",
      key: "Name",
      sorter: true,
      onFilter: () => true,
      ...getColumnSearchProps("name", false, "Asset Name"),
      filteredValue: searchColumns.name ? [searchColumns.name] : null,
      width: width <= 1440 ? "13%" : "18%",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.name}
        </Skeleton>
      ),
    },
    {
      title: "Code",
      dataIndex: "number",
      key: "Number",
      sorter: true,
      onFilter: () => true,
      ...getColumnSearchProps("number", false, "Code"),
      filteredValue: searchColumns.number ? [searchColumns.number] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.number}
        </Skeleton>
      ),
    },
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "GroupName",
      sorter: true,
      onFilter: () => true,
      ...getColumnSearchProps("groupName", false, "Group Name"),
      filteredValue: searchColumns.groupName ? [searchColumns.groupName] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.groupName}
        </Skeleton>
      ),
    },
    {
      title: "Pur Price",
      dataIndex: "purPrice",
      key: "PurPrice",
      sorter: true,
      onFilter: () => true,
      ...getColumnSearchProps("purPrice", true, "Purchase Price"),
      filteredValue: searchColumns.purPrice ? [searchColumns.purPrice] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {Utils.getFormattedNumber(record?.purPrice)}
        </Skeleton>
      ),
    },
    {
      title: "GST",
      dataIndex: "taxRate",
      key: "Rate",
      width: "8%",
      sorter: true,
      onFilter: () => true,
      ...getColumnSearchProps("taxRate", false, "GST"),
      filteredValue: searchColumns.taxRate ? searchColumns.taxRate : null,
      // sorter: true,
      // filters: [
      //   {
      //     text: "5%",
      //     value: 5,
      //   },
      //   {
      //     text: "3%",
      //     value: 3,
      //   },
      // ],
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.taxRate}
        </Skeleton>
      ),
    },
    {
      title: "Depreciable Asset",
      dataIndex: "isDepreciable",
      align: "center",
      onFilter: () => true,
      ...getColumnSearchProps("isDepreciable", false, "Depreciable Asset"),
      filteredValue: searchColumns.isDepreciable
        ? searchColumns.isDepreciable
        : null,
      render: (val) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: {
              display: "flex",
              flexDirection: "column",
            },
          }}
          title={false}
        >
          {val ? "Yes" : "No"}
        </Skeleton>
      ),
    },
    {
      title: "Action",
      dataIndex: "id",
      align: "center",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "center" },
          }}
          title={false}
        >
          <>
            {permissionEdit ? (
              record.status !== AssetStatus_New.Disposed ? (
                <Tooltip title="Edit" color="#444653" placement="top">
                  <EditOutlined
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setAssetModelOpen({
                        open: true,
                        param: record.id,
                        openingAsset:
                          record?.itemAddType === ItemAdd_Type.Opening
                            ? true
                            : false,
                      });
                    }}
                  />
                </Tooltip>
              ) : (
                ""
              )
            ) : (
              <></>
            )}
          </>
        </Skeleton>
      ),
    },
  ];

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <>
      <Card
        size="small"
        className="TableCard"
        style={{
          // width: "97%",
          // marginLeft: "16px",
          marginTop: 35,
          // padding: "48px 0px 0px 0px",
          boxShadow: "0px 0px 10px 0px #96A1C84D",
        }}
      >
        <Row
          justify={"space-between"}
          style={{
            // paddingTop: props?.partyId ? "10px" : "0px"
            // marginTop: 10,
            padding: "0px 0px 3px 0px",
          }}
        >
          {findUserPremission(
            ["Voucher.Asset.11.Add"],
            clientSpecificRole(),
            currentClient?.id!,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.Add,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          ) && (
            <Col>
              <Row gutter={10}>
                {!assetPurchaseType && (
                  <Col>
                    <Button
                      type="primary"
                      onClick={() =>
                        setAssetModelOpen({
                          open: true,
                          param: "",
                          openingAsset: false,
                        })
                      }
                    >
                      <PlusOutlined />
                      Asset Item
                    </Button>
                  </Col>
                )}
                <Col>
                  <Popover
                    content={content}
                    placement="rightTop"
                    trigger="hover"
                  >
                    {/* <CbExportButton /> */}
                    <Button
                      type="default"
                      icon={<DownloadOutlined />}
                      // onClick={() => exportCsv()}
                    >
                      Export
                    </Button>
                  </Popover>
                </Col>
              </Row>
            </Col>
          )}

          <Col>
            <Row gutter={10}>
              <Col>
                <Input
                  style={{ width: "200px" }}
                  placeholder="Search asset"
                  allowClear
                  onChange={(e: any) => {
                    setPage(1);
                    setSearchAsset(e.target.value);
                    //console.log(e.target.value, "search");
                  }}
                  suffix={
                    loading || searchAsset ? (
                      ""
                    ) : (
                      <img alt="search" src={search} />
                    )
                  }
                />
              </Col>

              <Col style={{ justifyContent: "end", gap: 10 }}>
                <Select
                  defaultValue={AssetStatus_New.Active}
                  style={{ width: 120 }}
                  options={[
                    { value: AssetStatus_New.All, label: "All", title: "" },
                    {
                      value: AssetStatus_New.Active,
                      label: "Active",
                      title: "",
                    },
                    {
                      value: AssetStatus_New.Disposed,
                      label: "Disposed",
                      title: "",
                    },
                  ]}
                  onChange={(e: any) => {
                    setChangeStatus(e);
                    console.log(e, "changestatusassets");
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <Table
          className={`Tabel-style table-${
            themeData?.componentSize ?? "middle"
          }`}
          columns={columns}
          onChange={(pagination, filters, sorter) => tableSort(sorter)}
          dataSource={
            loading
              ? (Array.from({ length: pageSize }, (_, index) => ({
                  key: `loading-${index}`,
                })) as IFAListResponse[])
              : fixedAssetList
          }
          // expandable={{
          //   expandedRowRender: test,
          //   // expandedRowRender: (_: any, record: any) => {
          //   //   console.log("Sel Record: ", record);
          //   //   return expandedRowRender(record?.invoiceDetail);
          //   // },
          //   defaultExpandAllRows: true,
          // }}
          pagination={{
            total: totalRecords,
            current: page,
            pageSize: pageSize,
            showSizeChanger: true,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
            },
            pageSizeOptions: tablePageSizeOptions,
          }}
          locale={{
            triggerDesc: "",
            triggerAsc: "",
            cancelSort: "",
          }}
          // scroll={
          //   pageSize > 15 ? { x: 1300, y: window.innerHeight - 300 } : undefined
          // }
        />
      </Card>
      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => {
            setDeleteOrRevive({
              id: assetId,
              isRev: changeStatus === AssetStatus_New.Disposed ? true : false,
            });
            //console.log("yogesh");
            setConfirmation(false);
          }}
          text={
            changeStatus === AssetStatus_New.Disposed
              ? `Are you sure you want to revive ?`
              : `Are you sure you want to Delete this row ?`
          }
        />
      )}
      {assetModelOpen.open && (
        <AddAssetItems
          open={assetModelOpen.open}
          onCancel={() =>
            setAssetModelOpen({ open: false, param: "", openingAsset: false })
          }
          oldPurchaseType={assetModelOpen.openingAsset!}
          setAssetModelOpen={setAssetModelOpen}
          setTrigger={setTrigger}
          editAssetId={assetModelOpen.param}
        />
      )}
      {isViewModelOpen && (
        <ViewAssetModel
          isViewModelOpen={isViewModelOpen}
          onCancel={() => setIsViewModelOpen(false)}
          assetId={assetId}
          type={type}
        />
      )}
      {journalModel.open && (
        <AssetJournalModal
          modal={journalModel}
          setSuccess={setSeccesRollBack}
          success={successRollBack}
          setModal={setJournalModel}
        />
      )}
    </>
  );
};
export default AssteItemsTable;
